module.exports = __webpack_public_path__ + "static/snowboarding-2-3b210538674e3769732a2f280dc0205a.jpg";